<div class="cnslng_cmn" >
    <figure>
        <img src="assets/images/cnslng_cmn.png" alt="show icon">
    </figure>
    <h2>{{'Dontmissoutonmastering' | translate}} <br> {{'newskills' | translate}}</h2>
    <p>{{'20%offyourcourseenrollment!' | translate}}</p>
    <button>{{'BuyNow' | translate}}</button>
</div>